class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('.js-close');
    this.header = document.querySelector('sticky-header');
    this.body = document.querySelector('body');
    this.closeBtn.addEventListener('click', this.hideBar.bind(this))
  }

  hideBar = () => {
    this.globaleBanner = document.querySelector('.ge-free-shipping-container')

    this.remove();
    if(this.globaleBanner) {
      this.globaleBanner.remove()
    }
    this.header.style.transform = 'translateY(0)';
    this.body.classList.add('announcement-hidden', 'cross-banner-hidden')
    document.documentElement.style.setProperty('--bar-height', `0px`)

    document.dispatchEvent(new Event("REINIT_SCROLL_ELEMENTS"));
    if (!this.hiddenBar) {
      sessionStorage.setItem('hiddenBar', true);
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);
